module.exports = __webpack_public_path__ + "static/media/account_setting.9c7a9039.svg";